var map = {
	"./mobileBlack/introduceText.png": 8195,
	"./mobileBlack/introduceText1.png": 6589,
	"./mobileBlack/introduceText2.png": 5643,
	"./mobileBlack/introduceText3.png": 7098,
	"./mobileBlack/introduceText4.png": 1761,
	"./pcBlack/introduceText1.png": 5652,
	"./pcBlack/introduceText2.png": 7631,
	"./pcBlack/introduceText3.png": 2488,
	"./pcBlack/introduceText4.png": 6411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7072;